/* global gtag */
import React, { useState, useEffect } from "react";
import { Form, FormGroup, Spinner, Alert, Fade } from "reactstrap";
import {
  ButtonLogin,
  InputLogin,
  ForgotPassLink,
  FormContainer,
  EyeIcon,
  ButtonRegister,
  RegisterBox,
  Suport,
} from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faKey } from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import api from "../../services/client/api";
import cookie from "../../services/cookie/index";
import { isCpfValid } from "../../utils/cpfValidate";
function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [inProgress, setInProgress] = useState(false);
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [alertError, setAlertError] = useState("");
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    if (alertError) {
      setShowAlert(true); // mostra com fade

      const timeout = setTimeout(() => {
        setShowAlert(false); // começa a esconder com fade
        // depois que sumir, limpa o conteúdo
        setTimeout(() => setAlertError(""), 300); // tempo igual ao da animação
      }, 5000);

      return () => clearTimeout(timeout);
    }
  }, [alertError]);

  const applyCpfMask = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const match = cleanedValue.match(/^(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,2})$/);
    if (match) {
      return `${match[1]}${match[2] ? "." + match[2] : ""}${match[3] ? "." + match[3] : ""}${match[4] ? "-" + match[4] : ""}`;
    }

    return value;
  };

  const login = async (e) => {
    e.preventDefault();

    let cleanedUsername = username.replace(/\D/g, "");

    // Verifica se o CPF tem exatamente 11 caracteres
    if (cleanedUsername.length !== 11) {
      alert("CPF deve conter 11 dígitos.");
      setInProgress(false); // Reseta o estado de "em progresso"
      return;
    }
    if (!isCpfValid(cleanedUsername)) {
      setAlertError("CPF inválido.");
      setInProgress(false);
      return;
    }

    setUsername(cleanedUsername); // Atualiza o estado com o username limpo

    setInProgress(true);

    try {
      const response = await api()
        .user()
        .login({ username: cleanedUsername, password });

      switch (response.status) {
    

        case 428:
          // await cookie().set("token", response.data.token, 60 / 1440);
          // 🔵 GA4: First Login
          gtag("event", "first_login", {
            event_category: "auth",
            value: 428,
          });

          if (response.data.data.accepted_terms) {
            setInProgress(false);
            history.replace({
              pathname: "/info-verify",
              state: {
                username: username,
                verification_form: response.data.data.verification_form,
                mail: response.data.data.email,
                tel: response.data.data.tel,
                id: response.data.data.id,
              },
            });

            break;
          } else {
            setInProgress(false);
            history.replace({
              pathname: "/terms",
              state: {
                username: username,
                verification_form: response.data.data.verification_form,
                mail: response.data.data.email,
                tel: response.data.data.tel,
                id: response.data.data.id,
              },
            });

            break;
          }

        case 403:
          // 🔵 GA4: First Login
          gtag("event", "first_login", {
            event_category: "auth",
            value: 403,
          });
          history.replace({
            pathname: "/replace-pass",
            state: {
              username: username,
              id: response.data.data,
            },
          });
          break;

        case 200:
          if (response.output?.user) {
            await cookie().set("token", response.output.token, 30 / 1440);
            await cookie().set("username", username, 30 / 1440);
            await cookie().set("name", response.output.user.name, 30 / 1440);
            await cookie().set("role", response.output.user.role, 30 / 1440);
            // ✅ GA4: Login Success
            gtag("event", "login_success", {
              event_category: "auth",
              value: 200,
            });
            history.replace({
              pathname: "/",
            });
          }
          break;

              case 401:
          const newLoginAttempts = loginAttempts + 1;
          setLoginAttempts(newLoginAttempts);
          setAlertError("error");
          // 🔴 GA4: Login Attempt
          gtag("event", "login_attempt", {
            event_category: "auth",
            value: 401,
          });
          break;

        default:
          // Trate outros status inesperados aqui se necessário
          break;
      }
    } catch (err) {
      console.error("Erro ao fazer login:", err);
    } finally {
      setInProgress(false);
    }
  };

  return (
    <>
      <FormContainer>
        <h1>Área&nbsp;Paciente</h1>
        <Form onSubmit={login}>
          <FormGroup>
            <span
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: 650,
                fontSize: "17px",
                color: "#6c757d",
                textAlign: "left",
              }}
            >
              CPF:
            </span>
            <InputLogin
              type="text"
              placeholder="Digite seu CPF"
              value={applyCpfMask(username)}
              maxLength="14"
              onChange={(e) => {
                // Apenas números podem ser digitados no input
                setUsername(e.target.value.replace(/\D/g, ""));
              }}
              required
              autoComplete="username"
            />
          </FormGroup>

          <FormGroup>
            <span
              style={{
                display: "block",
                marginBottom: "5px",
                fontWeight: 650,
                fontSize: "17px",
                color: "#6c757d",
                textAlign: "left",
              }}
            >
              Senha:
            </span>
            <div style={{ position: "relative" }}>
              <InputLogin
                type={showPassword ? "text" : "password"}
                placeholder="Digite sua senha"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <EyeIcon
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </EyeIcon>
            </div>
          </FormGroup>

          <ButtonLogin
            color="primary"
            type="submit"
            title="Para acessar você deve fornecer as credenciais de acesso, ou criar uma conta."
          >
            {inProgress ? <Spinner size="sm" color="light" /> : "Acessar"}
            <FontAwesomeIcon icon={faArrowRight} />
          </ButtonLogin>

          <div>
            <center>
              <Fade in={showAlert} timeout={400}>
                {alertError && (
                  <Alert color="danger">Login ou senha incorretos.</Alert>
                )}
              </Fade>
            </center>
          </div>
        </Form>
      </FormContainer>

      <RegisterBox>
        <h4 style={{ fontWeight: 600 }}>Ainda não tem cadastro?</h4>
        <span style={{ fontSize: "15px" }}>
          Crie sua conta agora para acessar seus laudos com segurança.
        </span>

        <ButtonRegister onClick={() => history.push("/cpf-user-check")}>
          Cadastrar agora
        </ButtonRegister>
      </RegisterBox>

      <ForgotPassLink
        onClick={() => {
          setInProgress(true);
          history.push("/forgot-pass");
        }}
      >
        Recuperação de Senha
        <FontAwesomeIcon icon={faKey} />
      </ForgotPassLink>
   <Suport href="https://wa.me/5547991153595" target="_blank">
        <u>Suporte</u>
        <FontAwesomeIcon icon={faWhatsapp} color="#25d366" />
      </Suport>
    </>
  );
}

export default Login;
